import { Component, OnInit, ElementRef } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { CommunicationService } from './common/services/Communication.service';
import { Router, NavigationEnd } from '@angular/router';
import { dataModel, Routers } from './models/data.model';
import { Subscription } from 'rxjs';
import { NavigationClick } from './methods/methods';

// tslint:disable-next-line: ban-types
declare let ga: Function;

export let browserRefresh = false;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass'],
  animations: [
    trigger('fadeInOut', [
      state('void', style({
        opacity: 0
      })),
      transition('void <=> *', animate(2000)),
    ]),
  ],
})

export class AppComponent implements OnInit  {
  data: dataModel;
  routingState: Routers;
  subscription: Subscription;

  constructor(
    communicationService: CommunicationService,
    private elRef: ElementRef,
    private router: Router,
    public onClick: NavigationClick) {

    this.data = communicationService.data;
    this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          ga('set', 'page', event.urlAfterRedirects);
          ga('send', 'pageview');
        }
      });
  }

  ngOnInit() {
    const doc = document.documentElement;
    doc.setAttribute('data-useragent', navigator.userAgent);
    const checked = localStorage.getItem('currentUser');
    if (JSON.parse(checked)) {
      const now = (new Date()).getTime();
      if ( (now - JSON.parse(checked).timestamp) >  36000000 ) {
        localStorage.clear();
      }
    }
  }
}
